import { render, staticRenderFns } from "./NotificationSample.vue?vue&type=template&id=3da03a1f"
import script from "./NotificationSample.vue?vue&type=script&lang=js"
export * from "./NotificationSample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports